{
  "LOGIN": {
    "TITLE": "Melden Sie sich beim Kontaktcenter an",
    "EMAIL": {
      "LABEL": "E-Mail",
      "PLACEHOLDER": "example{'@'}companyname.com",
      "ERROR": "Bitte geben Sie eine gültige E-Mail-Adresse ein"
    },
    "PASSWORD": {
      "LABEL": "Passwort",
      "PLACEHOLDER": "Passwort"
    },
    "API": {
      "SUCCESS_MESSAGE": "Anmeldung erfolgreich",
      "ERROR_MESSAGE": "Es konnte keine Verbindung zum Woot Server hergestellt werden. Bitte versuchen Sie es später erneut",
      "UNAUTH": "Benutzername / Passwort falsch. Bitte versuche es erneut",
      "ACCOUNT_DEACTIVATED": "Ihr Konto wurde deaktiviert. Bitte wenden Sie sich an Ihren Administrator.",
      "PASSWORD_LOGIN_DISABLED": "Die Passwort-Anmeldung ist für Ihr Konto deaktiviert. Bitte melden Sie sich über OAuth an (z. B. Google)."
    },
    "OAUTH": {
      "GOOGLE_LOGIN": "Mit Google anmelden",
      "BUSINESS_ACCOUNTS_ONLY": "Bitte verwenden Sie Ihre Firmen-E-Mail-Adresse zum Anmelden",
      "NO_ACCOUNT_FOUND": "Wir konnten kein Konto für Ihre E-Mail-Adresse finden."
    },
    "FORGOT_PASSWORD": "Haben Sie Ihr Passwort vergessen?",
    "CREATE_NEW_ACCOUNT": "Neuen Account erstellen",
    "SUBMIT": "Einloggen"
  }
}
